var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card shadow-sm" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("h3", { staticClass: "card-title mb-4" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("actions.edit")) +
                ":\n                " +
                _vm._s(
                  _vm.isInvoice
                    ? _vm.$t("pages.subscription.start.address.invoice_address")
                    : _vm.$t(
                        "pages.subscription.start.address.delivery_address"
                      )
                ) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c("static-loading-indicator-icon", {
            attrs: { loading: _vm.$store.getters.shouldLoadLocal }
          }),
          _vm._v(" "),
          !_vm.$store.getters.shouldLoadLocal
            ? _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.updateAddress($event)
                    }
                  }
                },
                [
                  _vm.isDelivery
                    ? _c("div", {
                        staticClass: "alert alert-danger shadow-sm",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "pages.subscription.start.address.delivery_add_lux_only"
                            )
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.address !== null
                    ? _c("address-form", {
                        attrs: {
                          value: _vm.address,
                          "validation-name-prefix": "",
                          "lux-only": _vm.isDelivery
                        },
                        on: {
                          input: function($event) {
                            _vm.address = $event
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("button", { staticClass: "btn btn-outline-dark" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("actions.update")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-outline-secondary ml-3",
                      attrs: { tag: "button", to: { name: "account.address" } }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("actions.cancel")) +
                          "\n                "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }